<template>
  <div class="col px-0">
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <div class="text-subtitle-1 text-sm-h6 text-md-h5 font-weight-bold text-center">
      Relatório de Vendas por Cliente - Analítico
    </div>

    <v-card>  
      <v-card-title>
        <span>Filtros</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-switch v-model="isSaleOrder" hide-details :label="`${isSaleOrder ? 'Pedidos' : 'Vendas'}`"></v-switch>
          </v-col>
          <v-col cols="12" md="6" >
            <v-autocomplete
              v-model="cultureIds"
              label="Cultura(s)"
              :items="filtersList ? filtersList.accountContext.allCultures : []"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="cultureIds = []"
              :loading="loadingFilters"
              multiple
              chips
              dense
              deletable-chips
              hint="Se nenhuma cultura for selecionada, todas serão exibidas"
              persistent-hint
            />
          </v-col>
          
          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="clientIds"
              label="Cliente(s)"
              :items="filtersList ? filtersList.accountContext.allCustomers : []"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="clientIds = []"
              :loading="loadingFilters"
              multiple
              chips
              dense
              deletable-chips
              hint="Se nenhum cliente for selecionado, todos serão exibidos"
              persistent-hint
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="productIds"
              label="Produto(s)"
              :items="filtersList ? filtersList.accountContext.productsInSales : []"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="productIds = []"
              :loading="loadingFilters"
              multiple
              chips
              dense
              deletable-chips
              hint="Se nenhum produto for selecionado, todos serão exibidos"
              persistent-hint
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="itemLotNumbersIds"
              label="Lote(s)"
              :items="filtersList ? filtersList.accountContext.salesLotNumbers.itemLotNumbers : []"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="itemLotNumbersIds = []"
              :loading="loadingFilters"
              multiple
              chips
              dense
              deletable-chips
              hint="Se nenhum lote for selecionado, todos serão exibidos"
              persistent-hint
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-autocomplete
              v-model="saleLotNumbersIds"
              label="Lote(s) de venda"
              :items="filtersList ? filtersList.accountContext.salesLotNumbers.saleLotNumbers : []"
              item-value="id"
              item-text="name"
              clearable
              @click:clear="saleLotNumbersIds = []"
              :loading="loadingFilters"
              multiple
              chips
              dense
              deletable-chips
              hint="Se nenhum lote de venda for selecionado, todos serão exibidos"
              persistent-hint
            />
          </v-col>

          <v-col cols="6" md="3">
            <v-autocomplete
              v-model="periodFilterModel"
              label="Período"
              :items="periodFilterOptions"
              item-value="key"
              item-text="name"
            />
          </v-col>
          <v-col cols="12" md="4" v-if="periodFilterModel == 'OTHER'">
            <DateRangeField
              :inputData.sync="periodFilterRangeModel"
              label="Período Customizado"
              :hasTodayDate="true"
            />
          </v-col>

          <v-col cols="6" md="2">
            <v-btn
              class="mt-3"
              @click="runFilter(false)">
              <v-icon left>mdi-magnify</v-icon>
              Filtrar
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <div>
      <BasePrint
        printableElementId="salesByProductsReportPrintTable"
        printButtonLabel="Imprimir"
        printTitle="Relatório de Vendas por Produto - Analítico"
        @start-printing="printing = loading = true"
        @stop-printing="printing = loading = false"
        class="mt-3"
      />
    </div>

    <div id="salesByProductsReportPrintTable" v-if="salesByProductAnalyticReport" class="mt-5">

      <v-row v-for="sale in salesByProductAnalyticReport.sales" v-bind:key="sale.fiscalDocumentNumber">
        <v-col cols="12" md="12">
          <v-card>
            <v-card-title class="py-2">
              <span class="text-h6">Cliente</span>
            </v-card-title>

            <v-card-text class="text-right">
              <span class="font-weight-bold text-subtitle-1 text-sm-h6">
                {{sale.customerName}}
              </span>
            </v-card-text>
          </v-card>
        </v-col>        

        <v-col cols="12">
          <BaseIndex
            ref="baseIndex"
            v-if="salesByProductAnalyticReport"
            :loading="loading"
            :pageLoading="pageLoading"
            :table-headers="tableHeaders"
            :table-items="sale.products"
            :maskFields="maskFields"
            :enableCustomFilters="false"
            :containTopToolbar="false"
            :itemsPerPage="-1"
            :disablePagination="true"
            :indexNested="true"
            :hasDefaultPageTitle="false"
          >                    

          </BaseIndex>
        </v-col>              
          <v-col cols="6" md="6">
          <v-card>
            <v-card-title class="py-2">
              <span class="text-h6">Qtd. Total: </span>
            </v-card-title>

            <v-card-text class="text-right">
              <span class="font-weight-bold text-subtitle-1 text-sm-h6">
                {{sale.productsTotalQuantity | formatNumber}}
              </span>
            </v-card-text>
          </v-card>
          </v-col>
          <v-col cols="6" md="6">
          <v-card>
            <v-card-title class="py-2">
              <span class="text-h6">Valor Total: </span>
            </v-card-title>

            <v-card-text class="text-right">
              <span class="font-weight-bold text-subtitle-1 text-sm-h6">
                {{sale.productsTotalValue | formatCurrency}}
              </span>
            </v-card-text>
          </v-card>
        </v-col>  
        <v-divider></v-divider>  

      </v-row>

      <v-row v-if="salesByProductAnalyticReport">
        <v-col cols="12">
          <v-card>
            <v-card-title class="py-2">
              <span class="text-h6">Valor Total</span>
            </v-card-title>

            <v-card-text class="text-right">
              <span class="font-weight-bold text-h6">
                {{salesByProductAnalyticReport.totalValue | formatCurrency}}
              </span>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import BaseIndex from "@shared_components/base_index.vue";
import DateRangeField from "@shared_components/date_range_field.vue"
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
   return {
      loading: false,
      loadingFilters: false,
      pageLoading: false,
      monthFilter: moment().format('YYYY-MM'),
      cultureIds: [],
      clientIds: [],
      isSaleOrder: false,
      productIds: [],
      salesByProductAnalyticReport: null,
      startDate: null,
      endDate: null,
      filtersList: null,
      tableHeaders: [
        { text: "Cód. Produto", align: "left", sortable: false, value: "itemCode"},
        { text: "Produto", align: "left", sortable: false, value: "itemName"},
        { text: "Unidade", align: "left", sortable: false, value: "unitName"},
        { text: "Quantidade", align: "left", sortable: false, value: "quantity"},
        { text: "Valor unitário", align: "left", sortable: false, value: "unitPrice"},
        { text: "Valor Total", align: "left", sortable: false, value: "price"},
        { text: "Nº NF-e", align: "left", sortable: false, value: "nfeNumber"},
        { text: "Data", align: "left", sortable: false, value: "billDate"},
        { text: "Lote", align: "left", sortable: false, value: "itemLotNumber"}, //pode ser removido no loadServerEntries (precisam ser os dois ultimos)
        { text: "Lote de Venda", align: "left", sortable: false, value: "saleLotNumber"}, //pode ser removido no loadServerEntries (precisam ser os dois ultimos)
      ],
      maskFields: [
        { field: 'quantity', mask: 'number' },
        { field: 'unitPrice', mask: 'currency' },
        { field: 'price', mask: 'currency' },
        {field: 'billDate', mask: 'date'},
        // { field: 'status', mask: 'status_color', colorField: 'statusColor' },
      ],
      periodFilterOptions: [
        { "key": "DAY", "name": "Hoje" },
        { "key": "WEEK", "name": "Esta Semana" },
        { "key": "MONTH", "name": "Este Mês" },
        { "key": "OTHER", "name": "Customizado" },
      ],
      periodFilterModel: "MONTH",
      periodFilterRangeModel: [moment().startOf('week').format('YYYY-MM-DD'), moment().endOf('week').format('YYYY-MM-DD')]
    }
  },
  props: {
    enabledLot: {
      type: Boolean,
      default: true,
    },
    headers:{
      type: Array,
      default: Array.new,
    },
  },
  components: {
    BaseIndex: BaseIndex,
    DateRangeField: DateRangeField,
    BasePrint: BasePrint,
  },  
  created() {
    this.loadServerFilters();
  },
  mounted() {
    // console.log("aa", this.tableHeaders);
    // this.tableHeaders.pop();
  },
  methods: {
    loadServerFilters: function() {
      this.loadingFilters = true;
      this.$apollo
        .query({
          query: LOAD_FILTERS_QUERY,
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.filtersList = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loadingFilters = false));
    },
    loadServerEntries: function(firstLoading=false) {
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_SALES_PRODUCTS_BY_CUSTOMER_QUERY,
          variables: {
            cultureIds: this.cultureIds,
            clientIds: this.clientIds,
            productIds: this.productIds,
            startDate: this.startDate,
            endDate: this.endDate,
            itemLotNumbersIds: this.itemLotNumbersIds,
            saleLotNumbersIds: this.saleLotNumbersIds,
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          this.salesByProductAnalyticReport = response.data.accountContext.salesByCustomerAnalyticReport;
          // console.log("this.salesByProductAnalyticReport", this.salesByProductAnalyticReport);
          const have = this.salesByProductAnalyticReport.sales.find((sale)=> sale.products.find((item)=> item.itemLotNumber != ""));
          // console.log("have", have);
          if(have){
            var inTheTable = this.tableHeaders.find((table)=>table.text=="Lote");
            if(inTheTable){
              console.log('');
            }else{
              this.tableHeaders.push({ text: "Lote", align: "left", sortable: false, value: "itemLotNumber"});
              this.tableHeaders.push({ text: "Lote de Venda", align: "left", sortable: false, value: "saleLotNumber"});
            }
          }else{
            //removendo infos dos lotes !!!
            var inTheTable2 = this.tableHeaders.find((table)=>table.text=="Lote");
            if(inTheTable2){
              this.tableHeaders.pop();
              this.tableHeaders.pop();
            }
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    runFilter: function(firstLoading=false) {
      if (this.periodFilterModel != "OTHER") {
        this.startDate = moment().startOf(this.periodFilterModel.toLocaleLowerCase()).format('YYYY-MM-DD');
        this.endDate   = moment().endOf(this.periodFilterModel.toLocaleLowerCase()).format('YYYY-MM-DD');

      } else {
        if (this.periodFilterRangeModel.length == 2) {
          this.startDate = this.periodFilterRangeModel[0];
          this.endDate   = this.periodFilterRangeModel[1];
        }
      }
      // console.log(this.startDate, this.endDate);
      this.loadServerEntries(firstLoading);
      // this.startDate = moment(this.monthFilter, 'YYYY-MM').startOf('week').format('YYYY-MM-DD');
      // this.endDate   = moment(this.monthFilter, 'YYYY-MM').endOf('week').format('YYYY-MM-DD');
    },
  }
};

const LOAD_FILTERS_QUERY = gql `
  {
    accountContext {
      allCultures {
        id
        name
      }
      allCustomers {
        id
        name
      }
      productsInSales {
        id
        name
      }
      salesLotNumbers
    }
  }
`;

const LOAD_SALES_PRODUCTS_BY_CUSTOMER_QUERY = gql `
query ($startDate: ISO8601Date!, $endDate: ISO8601Date!, $cultureIds: [ID!]!, $clientIds: [ID!]!, $productIds: [ID!]!, $saleLotNumbersIds: [ID!], $itemLotNumbersIds: [ID!]) {
  accountContext {
    salesByCustomerAnalyticReport(cultureIds: $cultureIds, clientIds: $clientIds, productIds: $productIds, startDate: $startDate, endDate: $endDate, saleLotNumbersIds: $saleLotNumbersIds, itemLotNumbersIds: $itemLotNumbersIds)
  }
}
`;

</script>

<style scoped>
</style>
